"use client";

import {UserForm} from "./user-form";

type EditUserProps = {
  data: {
    client: Client;
    items: any;
    onCancel?: () => void;
    onSuccess?: () => void;
  };
};

export const EditUser: React.FC<EditUserProps> = ({data}) => {
  return (
    <div>
      <div className="mb-6 border-b border-default-200 pb-3">
        <h2 className="text-lg font-semibold">Edit User Details</h2>
      </div>
      <UserForm
        client={data?.client}
        items={data?.items}
        onCancel={data?.onCancel}
        onSuccess={data?.onSuccess}
        hideVehicleMappingFields
      />
    </div>
  );
};
